
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useLanguage } from '@/contexts/LanguageContext';

interface AuthGuardProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  requiredRole?: string[];
}

const AuthGuard: React.FC<AuthGuardProps> = ({ 
  children, 
  requireAuth = true, 
  requiredRole = [] 
}) => {
  const { user, profile } = useAuth();
  const { t } = useLanguage();
  const location = useLocation();

  if (requireAuth && !user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (!requireAuth && user) {
    return <Navigate to="/account" replace />;
  }

  if (requiredRole.length > 0 && profile && !requiredRole.includes(profile.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">
            {t('access_denied', 'غير مسموح بالوصول', 'Access Denied')}
          </h1>
          <p className="text-muted-foreground">
            {t('insufficient_permissions', 'لا تملك الصلاحيات الكافية', 'You do not have sufficient permissions to access this page.')}
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthGuard;
